(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/marketplace/create-game/assets/javascripts/product-selection-dropdown.js') >= 0) return;  svs.modules.push('/components/marketplace/create-game/assets/javascripts/product-selection-dropdown.js');
'use strict';

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const _React = React,
  useContext = _React.useContext,
  useCallback = _React.useCallback,
  useEffect = _React.useEffect,
  useState = _React.useState;
const _ReactRouterDOM = ReactRouterDOM,
  useHistory = _ReactRouterDOM.useHistory,
  useParams = _ReactRouterDOM.useParams;
const _ReactRedux = ReactRedux,
  useSelector = _ReactRedux.useSelector,
  useDispatch = _ReactRedux.useDispatch;
const getProductItems = svs.components.marketplaceData.createGame.helpers.getProductItems;
const selectProduct = svs.components.marketplaceData.createGame.actions.selectProduct;
const _svs$components$marke = svs.components.marketplace.marketplaceBrand,
  MarketplaceBrand = _svs$components$marke.MarketplaceBrand,
  MarketplaceBrandContext = _svs$components$marke.MarketplaceBrandContext;
const _svs$utils$products = svs.utils.products,
  resolveProductId = _svs$utils$products.resolveProductId,
  getDisplayName = _svs$utils$products.getDisplayName;
const getGame = svs.components.marketplaceData.selectors.games.getGame;
const _svs$ui$ReactDropdown = svs.ui.ReactDropdown,
  DropdownSelectItem = _svs$ui$ReactDropdown.DropdownSelectItem,
  DropdownItem = _svs$ui$ReactDropdown.DropdownItem,
  DropdownLabel = _svs$ui$ReactDropdown.DropdownLabel;
const _svs$components$lbUi$ = svs.components.lbUi.jackpotAndFunds.JackPotAndFunds,
  JackPotAndFunds = _svs$components$lbUi$.JackPotAndFunds,
  _formatJackpotAndFunds = _svs$components$lbUi$._formatJackpotAndFunds;
const showDialog = svs.components.marketplaceData.dialogWrapper.actions.showDialog;
const ProductSelectionDropdown = _ref => {
  let hasOpenProductOnLoad = _ref.hasOpenProductOnLoad;
  const dispatch = useDispatch();
  const history = useHistory();
  const _useContext = useContext(MarketplaceBrandContext),
    getBrandedDisplayName = _useContext.getBrandedDisplayName;
  const _useParams = useParams(),
    activatedDrawId = _useParams.activatedDrawId,
    groupId = _useParams.groupId;
  const game = useSelector(state => activatedDrawId && getGame(state, {
    activatedDrawId,
    groupId
  }));
  const _useSelector = useSelector(state => state.CreateGame || {}),
    availableProducts = _useSelector.availableProducts,
    selectedProduct = _useSelector.selectedProduct,
    isSelectedDrawClosed = _useSelector.isSelectedDrawClosed;
  const _useSelector2 = useSelector(state => state.Draws),
    draws = _useSelector2.draws;
  const _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    productItems = _useState2[0],
    setProductItems = _useState2[1];
  useEffect(() => {
    let isMounted = true;
    const setAriaLabels = () => {
      var _ref2, _document$querySelect;
      const dropdownList = document.querySelector('.dropdown-list');
      if (!isMounted || !dropdownList) {
        return;
      }
      dropdownList.setAttribute('aria-label', "Lista med ".concat(productItems.length, " produkter"));
      const dropdownListItems = dropdownList.querySelectorAll('.dropdown-list-item');
      (_ref2 = [...dropdownListItems]) === null || _ref2 === void 0 || _ref2.forEach(listItem => {
        const productItem = productItems === null || productItems === void 0 ? void 0 : productItems.find(_ref3 => {
          var _getDisplayName;
          let item = _ref3.item;
          const itemId = resolveProductId(item);
          const itemDisplayName = (_getDisplayName = getDisplayName(itemId)) === null || _getDisplayName === void 0 ? void 0 : _getDisplayName.toLowerCase();
          return listItem.innerText.toLowerCase().includes(itemDisplayName);
        });
        if (!productItem) {
          return;
        }
        const _ref4 = productItem || {},
          disabledReason = _ref4.disabledReason,
          isDisabled = _ref4.isDisabled,
          _ref4$jackpots = _ref4.jackpots,
          jackpots = _ref4$jackpots === void 0 ? [] : _ref4$jackpots,
          _ref4$funds = _ref4.funds,
          funds = _ref4$funds === void 0 ? [] : _ref4$funds;
        const productId = resolveProductId(productItem.item);
        const hasJackpotOrFunds = jackpots.length > 0 || funds.length > 0;
        let ariaLabel = getBrandedDisplayName(productId);
        if (disabledReason) {
          ariaLabel += ", ".concat(disabledReason);
        }
        if (hasJackpotOrFunds) {
          const jackpotFunds = _formatJackpotAndFunds({
            productId,
            jackpots,
            funds
          });
          if (jackpotFunds) {
            ariaLabel += ", ".concat(jackpotFunds.text);
          }
        }
        listItem.setAttribute('aria-label', ariaLabel);
        if (isDisabled) {
          listItem.setAttribute('aria-disabled', 'true');
          listItem.classList.add('dropdown-item-disabled');
        } else {
          listItem.removeAttribute('aria-disabled');
          listItem.classList.remove('dropdown-item-disabled');
        }
      });
      (_document$querySelect = document.querySelector('.dropdown-selected .dropdown-label')) === null || _document$querySelect === void 0 || _document$querySelect.setAttribute('id', 'dropdown-label');
    };
    const fetchProductItems = async () => {
      const currentProductItems = await getProductItems({
        allProductNames: availableProducts,
        drawsByProduct: draws
      });
      if (isMounted && (!productItems || JSON.stringify(productItems) !== JSON.stringify(currentProductItems))) {
        setProductItems(currentProductItems);
      }
    };
    fetchProductItems();
    setAriaLabels();
    if (isMounted) {
      if (!hasOpenProductOnLoad) {
        var _document$querySelect2;
        (_document$querySelect2 = document.querySelector('.dropdown-selected')) === null || _document$querySelect2 === void 0 || _document$querySelect2.focus();
      } else {
        var _document$querySelect3;
        (_document$querySelect3 = document.querySelectorAll('.dropdown-list-item')[0]) === null || _document$querySelect3 === void 0 || _document$querySelect3.focus();
      }
    }
    return () => {
      isMounted = false;
    };
  }, [availableProducts, draws, getBrandedDisplayName, productItems, hasOpenProductOnLoad]);
  const onSelectProduct = useCallback(productName => {
    const productIsDisabled = productItems.some(_ref5 => {
      let item = _ref5.item,
        isDisabled = _ref5.isDisabled;
      return productName === item && isDisabled;
    });
    const allClosed = productItems.every(_ref6 => {
      let isDisabled = _ref6.isDisabled;
      return isDisabled;
    });
    if (isSelectedDrawClosed && !allClosed) {
      dispatch(showDialog({
        title: 'Spelstopp är för nära',
        text: 'Spelstopp för omgången du valt är för nära. Välj en annan omgång.',
        icon: 'clock'
      }));
    }
    if (!productIsDisabled) {
      const searchParams = new URLSearchParams(history.location.search);
      if (searchParams.has('productName')) {
        searchParams.delete('productName');
        history.replace({
          search: "".concat(searchParams)
        });
      }
      if (searchParams.has('drawNumber')) {
        searchParams.delete('drawNumber');
        history.replace({
          search: "".concat(searchParams)
        });
      }
      dispatch(selectProduct(productName));
    }
  }, [dispatch, history, isSelectedDrawClosed, productItems]);
  if (activatedDrawId) {
    if (!(game !== null && game !== void 0 && game.productId)) {
      return null;
    }
    return React.createElement("div", {
      className: "control-group product-selection-show",
      "data-testid": "product-selection-show"
    }, React.createElement(MarketplaceBrand, {
      className: "product-selection-show-product",
      productId: game.productId,
      size: 100,
      square: true
    }), React.createElement("div", {
      className: "f-medium f-500 margin-top-1"
    }, getBrandedDisplayName(game.productId)));
  }
  if (!productItems) {
    return null;
  }
  return React.createElement("div", {
    className: "control-group",
    "data-testid": "product-selection-choose"
  }, React.createElement(DropdownSelectItem, {
    className: "select-product-list",
    isOpen: hasOpenProductOnLoad,
    onSelect: onSelectProduct,
    v2: true
  }, productItems.map((productItem, index) => {
    const productName = productItem.item,
      disabledReason = productItem.disabledReason,
      isDisabled = productItem.isDisabled,
      _productItem$jackpots = productItem.jackpots,
      jackpots = _productItem$jackpots === void 0 ? [] : _productItem$jackpots,
      _productItem$funds = productItem.funds,
      funds = _productItem$funds === void 0 ? [] : _productItem$funds;
    const productId = resolveProductId(productName);
    const hasJackpotOrFunds = jackpots.length > 0 || funds.length > 0;
    const key = "".concat(productId, "_").concat(index);
    return React.createElement(DropdownItem, {
      key: key,
      name: productName,
      selected: productName === selectedProduct
    }, React.createElement("div", {
      "aria-hidden": "true",
      className: "qa-product-selection-item-wrapper"
    }, React.createElement(MarketplaceBrand, {
      productId: productId,
      size: 100,
      square: true
    }), React.createElement(DropdownLabel, null, React.createElement("div", {
      className: "f-uppercase qa-product-selection-item-name"
    }, getBrandedDisplayName(productId))), Boolean(isDisabled) && React.createElement(DropdownLabel, {
      right: true
    }, React.createElement("div", {
      className: "qa-product-selection-disabled-reason"
    }, disabledReason)), hasJackpotOrFunds && React.createElement(DropdownLabel, {
      right: true
    }, React.createElement("div", {
      className: "product-selection-jackpot-funds"
    }, React.createElement(JackPotAndFunds, {
      funds: funds,
      jackpots: jackpots,
      productId: productId
    })))));
  })));
};
setGlobal('svs.components.marketplace.createGame.ProductSelectionDropdown', ProductSelectionDropdown);

 })(window);